package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.viewModel.LetterViewModel
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.di.koinGet
import io.horion.cv.styles.PersonalFormFullWidthStyle
import io.horion.cv.styles.PersonalFormHalfWidthStyle
import io.horion.cv.styles.PersonalFormMainColumnStyle
import io.horion.cv.styles.PersonalFormRowStyle
import org.jetbrains.compose.web.css.px
@OptIn(DelicateApi::class)
@Composable
fun DestinataireDetailsForm() {

    val letterViewModel = koinGet<LetterViewModel>()
    val letterUiState = letterViewModel.letterUiState


    Column(
        modifier = PersonalFormMainColumnStyle.toModifier()
    ) {

//        if (breakpoint >= Breakpoint.MD) {
//            Row(horizontalArrangement = Arrangement.spacedBy(20.px)) {
//
//                TextFormField(
//                    "Entreprise",
//                    letterUiState.entreprise,
//                    {
//                        letterViewModel.updateEnterprise(it)
//                    },
//                    Modifier.width(halfWidth)
//                )
//
//                TextFormField(
//                    "Contact",
//                    letterUiState.contact,
//                    {
//                        letterViewModel.updateContact(it)
//                    },
//                    Modifier.width(halfWidth)
//                )
//            }
//        } else {
//            Column(verticalArrangement = Arrangement.spacedBy(5.px)) {
//
//                TextFormField(
//                    "Entreprise",
//                    letterUiState.entreprise,
//                    {
//                        letterViewModel.updateEnterprise(it)
//                    },
//                    Modifier.width(fullWidth)
//                )
//
//                TextFormField(
//                    "Contact",
//                    letterUiState.contact,
//                    {
//                        letterViewModel.updateContact(it)
//                    },
//                    Modifier.width(fullWidth)
//                )
//            }
//        }

        Row(
            modifier = PersonalFormRowStyle.toModifier()
        ) {
            TextFormField(
                label = "Entreprise",
                value = letterUiState.enterprise,
                onValueChange = { letterViewModel.updateEnterprise(it) },
                modifier = PersonalFormHalfWidthStyle.toModifier()
            )

            TextFormField(
                label = "Contact",
                value = letterUiState.contact,
                onValueChange = { letterViewModel.updateContact(it) },
                modifier = PersonalFormHalfWidthStyle.toModifier()
            )
        }

        TextFormField(
            label = "Adresse e-mail",
            value = letterUiState.addressEmail,
            onValueChange = { letterViewModel.updateAdresseEmail(it) },
            modifier = PersonalFormFullWidthStyle.toModifier()
        )

//        if (breakpoint >= Breakpoint.MD) {
//            Row(horizontalArrangement = Arrangement.spacedBy(20.px)) {
//
//                TextFormField(
//                    "Code Postal",
//                    letterUiState.codePostal,
//                    {
//                        letterViewModel.updateCodePostal(it)
//                    },
//                    Modifier.width(halfWidth)
//                )
//
//                TextFormField(
//                    "Ville",
//                    letterUiState.ville,
//                    {
//                        letterViewModel.updateVille(it)
//                    },
//                    Modifier.width(halfWidth)
//                )
//            }
//        } else {
//            Column(verticalArrangement = Arrangement.spacedBy(5.px)) {
//
//                TextFormField(
//                    "Code Postal",
//                    letterUiState.codePostal,
//                    {
//                        letterViewModel.updateCodePostal(it)
//                    },
//                    Modifier.width(fullWidth)
//                )
//
//                TextFormField(
//                    "Ville",
//                    letterUiState.ville,
//                    {
//                        letterViewModel.updateVille(it)
//                    },
//                    Modifier.width(fullWidth)
//                )
//            }
//        }

        Row(
            modifier = PersonalFormRowStyle.toModifier()
        ) {
            TextFormField(
                label = "Code Postal",
                value = letterUiState.codePostal,
                onValueChange = { letterViewModel.updateCodePostal(it) },
                modifier = PersonalFormHalfWidthStyle.toModifier()
            )

            TextFormField(
                label = "Ville",
                value = letterUiState.ville,
                onValueChange = { letterViewModel.updateVille(it) },
                modifier = PersonalFormHalfWidthStyle.toModifier()
            )
        }
    }
}